function SummaryDeltaNegative({ element, value }) {
  let signal = "";

  if (value > 0)
    signal = "+";

  return (
    <div className="text-danger">
      ({signal}{element})
    </div>
  )
}

module.exports = SummaryDeltaNegative;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Dashboard/SummaryDelta/summary-delta-negative.jsx